module.exports = "/cyber/_next/static/images/pubgDesktopBanner-3ac58b7298cd43a814cf5dfa911aea9b.jpg";